import Card from "../UI/Card";
import Title from "../UI/Title";
import Text from "../UI/Text";
// @ts-expect-error pure js
import DisplayName from "../UI/DisplayName";
import type { Profile } from "../Profile/types";
import styles from "./CandidatPresentationCard.module.css";

interface CandidatPresentationCardProps {
  profiles: Profile[];
}

/** Texte libre écrit par chaque candidat pour se présenter au bailleur. */
export default function CandidatPresentationCard({
  profiles,
}: CandidatPresentationCardProps) {
  const presented = profiles.filter((profile) => profile.presentation);
  if (presented.length === 0) return null;

  return (
    <Card padding="md" className={styles.card}>
      <Title variant="deca" weight="bold" as="h2">
        {presented.length > 1
          ? "Présentation des candidats"
          : "Présentation du candidat"}
      </Title>
      {presented.map((profile) => (
        <div key={profile.id} className={styles.profile}>
          {presented.length > 1 && (
            <Text as="div" variant="deci" weight="bold">
              <DisplayName profile={profile} />
            </Text>
          )}
          <Text className={styles.text}>{profile.presentation}</Text>
        </div>
      ))}
    </Card>
  );
}
